import OptIn from '../OptIn/OptIn.class';
export default class ExperimentCOptInPopUp extends OptIn {

	
}
